import { Component, inject, OnInit } from '@angular/core';
import { ClusterResult, SiteResult } from '../../shared/models/generated/ziroModels';
import { CurrentClusterContext } from '../../shared/contexts/current-cluster.context';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';
import { ModalBodyClass } from '../modal-body';
import { ZiroFormStateService } from '../../forms/ziro-form-state.service';
import { Observable, of } from 'rxjs';
import { ZiroFormConfig } from '../../forms/ziro-forms-models';
import { ZiroSelectConfig } from '../../forms/fields/select/ziro-select.component';
import { sortBy } from 'lodash';
import { ClusterSite } from '../../helpdesk/shared/contexts/site.context';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ZiroFormsModule } from '../../forms/ziro-forms.module';
import { PipesModule } from '../../shared/pipes/pipes.module';

export interface SiteResultOption {
  label: string;
  value: string;
  group: string;
}

@Component({
  selector: 'ziro-site-picker-modal',
  templateUrl: './site-picker-modal.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, ZiroFormsModule, PipesModule],
})
export class SitePickerModalComponent extends ModalBodyClass implements OnInit {
  private currentClusterContext = inject(CurrentClusterContext);
  private modalComponent = inject<PromptModalComponent<any>>(PromptModalComponent);
  protected _ziroFormStateService: ZiroFormStateService;

  protected formConfig: ZiroFormConfig;
  ziroIcons = ZiroIcons;
  selectedSite: SiteResult;
  sites: SiteResult[];
  clusterMapping: ClusterSite[];
  isUserPartiallyLdapActive: boolean;
  otherClusters: ClusterResult[];

  ngOnInit(): void {
    this.sites = this.modalComponent.modalViewProperties.allowedSites;
    this.isUserPartiallyLdapActive = this.modalComponent.modalViewProperties.isUserPartiallyLdapActive;
    this.otherClusters = this.modalComponent.modalViewProperties.otherClusters;
    this.clusterMapping = this.modalComponent.modalViewProperties?.clusterMapping;
    const allowedSites = this.clusterMapping.map((clusterSite) => {
      return {
        label: clusterSite.site,
        value: clusterSite.id,
        group: clusterSite.cluster,
      } as SiteResultOption;
    });

    this.formConfig = {
      fields: {
        sitePickerSelect: {
          dataAutomation: 'ziro-select-input',
          componentConfig: new ZiroSelectConfig({
            options: sortBy(allowedSites),
            bindValue: 'label',
            clearWithInput: true,
            hideClear: true,
          }),
          required: true,
        },
      },
      options: {
        columnClasses: {
          label: 'd-none',
          input: 'col-12',
        },
      },
    } as ZiroFormConfig;
  }

  getClusters(): string {
    return this.otherClusters.map((cluster) => cluster.name).join(',  ');
  }

  submit(): Observable<SiteResult> {
    const selectedSiteName = this.formData.sitePickerSelect;
    this.selectedSite = this.sites.find((site) => {
      return site.name === selectedSiteName;
    });

    this.currentClusterContext.setCurrentClusterFromSite(this.selectedSite.id);
    return of(this.selectedSite);
  }
}
